function parseBooleanFlag(value) {
  if (typeof value === 'boolean') {
    return value
  }

  if (typeof value !== 'string') {
    return false
  }

  const normalizedValue = value.trim().toLowerCase()

  return normalizedValue === '1' || normalizedValue === 'true' || normalizedValue === 'yes'
}

export const MENTOR_CHAMBER_AUTO_JOIN_APP_OWNED_AGORA_FLAG =
  'mentorChamberAutoJoinAppOwnedAgora'

export function getMentorChamberAutoJoinRtcMigrationDebugInfo({
  sessionRoutingDecision,
} = {}) {
  const routingFlagEnabled =
    sessionRoutingDecision?.featureFlags?.[
      MENTOR_CHAMBER_AUTO_JOIN_APP_OWNED_AGORA_FLAG
    ] === true

  const envFlagEnabled = parseBooleanFlag(
    import.meta.env.VITE_ENABLE_MENTOR_CHAMBER_AUTO_JOIN_APP_OWNED_AGORA,
  )
  const envForceDisabled = parseBooleanFlag(
    import.meta.env.VITE_DISABLE_MENTOR_CHAMBER_AUTO_JOIN_APP_OWNED_AGORA,
  )

  const enabled = envForceDisabled ? false : routingFlagEnabled || envFlagEnabled

  return {
    enabled,
    selectedSurface: enabled ? 'app-owned-agora-surface' : 'legacy-agora-component',
    routingFlagEnabled,
    envFlagEnabled,
    envForceDisabled,
  }
}

export function resolveMentorChamberAutoJoinRtcMigrationEnabled({
  sessionRoutingDecision,
} = {}) {
  return getMentorChamberAutoJoinRtcMigrationDebugInfo({
    sessionRoutingDecision,
  }).enabled
}
